import GenesysWebMessengerHistoryService from './services/genesys-web-messenger-history'
import GenesysKnowledgeBaseService from './services/genesys-knowledge-base'
import notificationSoundUrl from '/src/assets/audio/notification.mp3'
import cookieConsentManager from './services/cookie-consent-manager'
import FacebookMessengerService from './services/facebookMessenger'
import MetricsCollectorService from './services/metrics-collector'
import GenesysCallbackService from './services/genesys-callback'
import FormSubmissionService from './services/form-submission'
import translations from '../config/locales/translations.js'
import callWaitSoundUrl from '/src/assets/audio/ziptone.mp3'
import TrueengageLogger from './services/trueengage-logger'
import GenesysAudioService from './services/genesys-audio'
import GenesysVideoService from './services/genesys-video'
import currentTimestamp from '../lib/current-timestamp'
import StatisticsService from './services/statistics'
import WhatsAppService from './services/whatsapp'
import CallbackService from './services/callback'
import BillingService from './services/billing'
import JwtParser from './helpers/jwt-parser'
import Visitor from '../app/models/visitor'
import TokenService from './services/token'
import templates from '../app/templates'
import config from '../config/config.js'
import AiService from './services/ai'
import Queue from './models/queue'
import Widget from '../app/widget'
import _ from 'underscore'

var EVENTS_EXLUDED_FROM_GOOGLE_ANALYTICS = ['notLimited']
const ActiveChannelTimeout = 1000 * 60 * 15
const logger = new TrueengageLogger()

export default class WidgetContainer {
  constructor(settings) {
    this.mode = 'widget'
    this.i18n = translations
    this.afterLoadingQueue = []
    this.afterSettingsQueue = []
    this.widgets = []
    this.activeWidgets = {}

    this.$element = document.querySelector('.cce-widget-container')

    if (settings == null) {
      settings = {}
    }

    this.setSettings(settings)
    this.addAgentClass()
    this.addResponsiveClass()
    this.initiateToken()
    this.loadedAt = currentTimestamp()
    this.firedTriggerComponentsByFilterId = []

    if (this.settings.isPassive) {
      this.isLoaded = true
    } else {
      logger.info('[container] postLocation')
      logger.info(this.settings)
      this.postLocation()
    }

    window.addEventListener(
      'blur',
      (e) => {
        this.handleExitIntent(e)
      },
      false
    )
    window.addEventListener('focus', this.updateTabList.bind(this))
    window.addEventListener('beforeunload', this.unloadTab.bind(this))

    this.notificationSound = new Audio(notificationSoundUrl)
    this.callWaitSound = new Audio(callWaitSoundUrl)
    this.isCallWaitSoundPlaying = true

    this.debugInstallation()

    this.tabId = Math.random().toString(36).substring(2, 11)
    sessionStorage.setItem('tabId', this.tabId)
    this.updateTabList()

    this.widgetIndex = 0
  }

  isNewestTab() {
    const tabIDs = JSON.parse(localStorage.getItem('trueengage-tabIDs')) || []
    const latestTabID = tabIDs[tabIDs.length - 1] // The newest tab is the last in the array
    return latestTabID === this.tabId
  }

  unloadTab() {
    const tabIDs = JSON.parse(localStorage.getItem('trueengage-tabIDs')) || []
    const index = tabIDs.indexOf(this.tabId)
    if (index > -1) {
      tabIDs.splice(index, 1) // Remove this tabID from the array
    }
    cookieConsentManager.setLocalStorageItem('trueengage-tabIDs', JSON.stringify(tabIDs), 'statistics')
    if (tabIDs.length === 0) {
      localStorage.removeItem('lastOpenedTab') // Remove timestamp if no tabs are open
    }
  }

  updateTabList() {
    const tabIDs = JSON.parse(localStorage.getItem('trueengage-tabIDs')) || []
    const index = tabIDs.indexOf(this.tabId)

    if (index > -1) {
      tabIDs.splice(index, 1)
    }

    tabIDs.push(this.tabId)
    cookieConsentManager.setLocalStorageItem('trueengage-tabIDs', JSON.stringify(tabIDs), 'statistics')
  }

  setActiveChannel(channelSettings, widgetId = -1) {
    channelSettings['timestamp'] = Date.now()
    try {
      if (widgetId === -1) widgetId = this.settings.widgets[this.widgetIndex].id
      cookieConsentManager.setLocalStorageItem(`trueengage-activeChannel-${widgetId}-${this.token}`, JSON.stringify(channelSettings), 'necessary')
    } catch (e) {}
  }

  getActiveChannel(widgetId) {
    const channel = localStorage.getItem(`trueengage-activeChannel-${widgetId}-${this.token}`)
    if (channel) {
      const parsedChannel = JSON.parse(channel)
      const now = Date.now()
      if (now - parsedChannel['timestamp'] < ActiveChannelTimeout) {
        //15 minute active chat timeout
        return parsedChannel
      }
    }
    return null
  }

  playNotificationSound() {
    this.notificationSound.play().catch(() => {})
    document.querySelector('.cce-widget__bubble button').classList.add('notification--info')
    setTimeout(() => {
      document.querySelector('.cce-widget__bubble button').classList.remove('notification--info')
    }, 5000)
  }

  playRingtone() {
    if (!this.isCallWaitSoundPlaying) return
    this.callWaitSound.play()
    this.callWaitSound.onended = () => {
      if (this.isCallWaitSoundPlaying) {
        setTimeout(() => {
          this.playRingtone()
        }, 2500)
      }
    }
  }

  stopRingtone() {
    this.isCallWaitSoundPlaying = false
    this.callWaitSound.pause()
    this.callWaitSound.currentTime = 0
  }

  playZipSound() {
    this.callWaitSound.play()
  }

  detectUrlChange() {
    logger.info('[widget] detectUrlChange')
    if (this._previousUrl && this._previousUrl !== document.location.toString()) {
      logger.info('[widget] reload settings!')
      this.settingsLoaded = false
      this.settings.locationId = null
      this.activeWidgets = {}
      this.$element.innerHTML = ''
      this.postLocation()
    }

    this._previousUrl = document.location.toString()
  }

  initiateToken() {
    var token
    this.cookieName = 'cce-account-' + this.settings.id
    token = this.readCookie(this.cookieName)
    if (this.settings.visitorId) {
      this.token = this.settings.visitorId
      this.visitor = Visitor.find(this.token)
    } else if (token) {
      this.token = token
      this.visitor = Visitor.find(this.token)
    } else {
      this.visitor = new Visitor()
      this.visitor.save()
      this.token = this.visitor.id
      this.createCookie(this.cookieName, this.token, 'preferences')
    }

    let referrer = this.getReferrer()

    if (referrer && referrer !== this.visitor.referrer) {
      this.visitor.referrer = referrer
      this.visitor.save()
    }

    document.addEventListener('trueengage:consent_changed', () => {
      this.createCookie(this.cookieName, this.token, 'preferences')
    })
  }

  initiateGoogleAnalytics() {
    if (typeof gtag !== 'undefined') {
      // the variable is defined
      gtag('get', 'G-XXXXXXXXXX', 'client_id', (clientID) => {
        this.googleAnalyticsClientId = clientID
      })
    }
  }

  addAgentClass() {
    var agent, agents, i, item, len, pattern, results
    agents = [
      ['opera', 'OPR'],
      'chrome',
      'firefox',
      ['ie', 'Trident|msie'],
      'macintosh',
      'windows',
      'linux',
      'android',
      ['ios', 'iPad'],
      ['ios', 'iPhone'],
      ['ios', 'iPod'],
    ]
    results = []
    for (i = 0, len = agents.length; i < len; i++) {
      item = agents[i]
      if (typeof item === 'string') {
        pattern = agent = item
      } else {
        ;(agent = item[0]), (pattern = item[1])
      }
      if (new RegExp(pattern, 'i').exec(navigator.userAgent)) {
        const htmlElement = document.querySelector('html')
        htmlElement.classList.add('cce-' + agent)
      }
    }
    return results
  }

  isWidgetOpen() {
    return this.$element.querySelector('.cce-widget__window--open') !== null
  }

  addResponsiveClass() {
    let windowWidth = Math.min(window.innerWidth, window.screen.width)
    let breakpoints = [300, 390, 500]
    for (var i in breakpoints) {
      if (windowWidth < breakpoints[i]) {
        this.$element.classList.add('cce-width-' + breakpoints[i])
      } else {
        this.$element.classList.remove('cce-width-' + breakpoints[i])
      }
    }
    this.mobile = windowWidth < 500
  }

  handleExitIntent(event) {
    logger.info('[trigger] handleExitIntent')
    var from, widget
    from = event.relatedTarget || event.toElement
    if (from || event.clientY > 100) {
      return
    }
    widget = _.find(this.widgets, function (w) {
      return w.settings.triggers.some(function (t) {
        return t.kind === 'exitIntent'
      })
    })
    if (widget) {
      logger.info('[trigger] triggerExitIntent')
      return widget.triggerExitIntent()
    }
  }

  async refreshToken(token) {
    fetch(`${config.signalling.host}/accounts/${this.settings.id}/token`, {
      method: 'POST',
      body: JSON.stringify({ token: token }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((token) => {
        let decodedToken = JwtParser.parseJwt(token)
        const refreshTokenTime = decodedToken.exp * 1000 - Date.now()
        this.metricsCollector.token = token
        this.billingService.token = token

        setTimeout(() => {
          this.refreshToken(token)
        }, refreshTokenTime)
      })
      .catch((error) => {
        logger.error('Failed to refresh token', error)
      })
  }

  createServices(settings, billingToken, widgetIndex) {
    const billingService = new BillingService({
      host: config.billing.host,
      token: billingToken,
    })

    this.statisticsService = new StatisticsService(config.statistics.host, billingToken, settings.widgets, widgetIndex)

    const callbackService = new CallbackService({
      host: config.signalling.host,
      accountId: this.settings.id,
    })

    const genesysCallbackService = new GenesysCallbackService({
      host: config.signalling.host,
      accountId: this.settings.id,
    })

    const formSubmissionService = new FormSubmissionService({
      host: config.signalling.host,
      accountId: this.settings.id,
    })

    const genesysAudioService = new GenesysAudioService({
      host: config.signalling.host,
      accountId: this.settings.id,
    })

    const tokenService = new TokenService({
      host: config.signalling.host,
      accountId: this.settings.id,
    })

    const whatsappService = new WhatsAppService({
      host: config.signalling.host,
      accountId: this.settings.id,
    })

    const facebookMessengerService = new FacebookMessengerService({
      host: config.signalling.host,
      accountId: this.settings.id,
    })
    const genesysVideoService = new GenesysVideoService({
      host: config.signalling.host,
      accountId: this.settings.id,
    })

    const genesysWebMessengerHistoryService = new GenesysWebMessengerHistoryService({
      host: config.signalling.host,
    })

    const genesysKnowledgeBaseService = new GenesysKnowledgeBaseService({
      host: settings.genesysRegion,
      accountId: this.settings.id,
    })

    return {
      billingService,
      callbackService,
      genesysCallbackService,
      genesysAudioService,
      tokenService,
      whatsappService,
      facebookMessengerService,
      genesysWebMessengerHistoryService,
      genesysVideoService,
      genesysKnowledgeBaseService,
      formSubmissionService,
    }
  }

  async handleSettingsWithoutPredictiveEngagement(settings) {
    const localMlWhen = localStorage.getItem('trueengage-mlwhen')
    const localMlWhat = localStorage.getItem('trueengage-mlwhat')
    if (settings.widgets.length > 0) {
      if (localMlWhen) {
        settings.widgets[this.widgetIndex].mlWhen = localMlWhen
        settings.widgets[this.widgetIndex].aiWhen = !!localMlWhen
      }
      if (localMlWhat) {
        settings.widgets[this.widgetIndex].mlWhat = localMlWhat
        settings.widgets[this.widgetIndex].aiWhat = !!localMlWhat
      }
    }

    let decodedToken = JwtParser.parseJwt(settings.billingToken)
    const refreshTokenTime = decodedToken.exp * 1000 - Date.now()
    setTimeout(() => {
      this.refreshToken(settings.billingToken)
    }, refreshTokenTime)

    this.debugAccount()
    logger.info('[widget] handleSettings; geolocated ', settings)

    const {
      billingService,
      callbackService,
      genesysCallbackService,
      genesysAudioService,
      tokenService,
      whatsappService,
      facebookMessengerService,
      genesysWebMessengerHistoryService,
      genesysVideoService,
      genesysKnowledgeBaseService,
      formSubmissionService,
    } = this.createServices(settings, settings.billingToken)

    this.widgets = []
    this.settings.widgets.forEach((settings) => {
      let $element
      const $widgetWindow = templates.widgetWindow(this.getTemplateVariables())
      this.$element.insertAdjacentHTML('afterbegin', $widgetWindow)
      $element = this.$element
      const widgetIndex = this.widgetIndex

      if ($element && !this.settings.useGenesysPredictiveEngagement) {
        this.widgets.push(
          new Widget(this, $element, settings, settings.useGenesysPredictiveEngagement, {
            callbackService,
            genesysWebMessengerHistoryService,
            genesysCallbackService,
            genesysAudioService,
            billingService,
            tokenService,
            whatsappService,
            facebookMessengerService,
            widgetIndex,
            genesysVideoService,
            genesysKnowledgeBaseService,
            formSubmissionService,
          })
        )
      }
    })

    if (!this.isLoaded) {
      this.isLoaded = true
      this.executeAfterLoadingQueue()
    }
    if (!this.settingsLoaded) {
      this.settingsLoaded = true
      this.executeAfterSettingsQueue()
      this.trackPageView()
      this.triggerGoogleTagManagerEvent('visitor_id_set', { visitor_id: this.token })
      this.triggerPublicEvent('widget_loaded')
    }

    let activeWidget = this.widgets[this.widgetIndex]

    const availableChannels = this.widgets[this.widgetIndex].channels.map((x) => x.channelType)
    this.metricsCollector = new MetricsCollectorService(
      {
        host: config.ai.host,
        statisticsHost: config.statistics.host,
        accountId: this.settings.id,
        widgetId: this.widgets[this.widgetIndex].settings.id,
        visitorId: this.visitor.id,
        availableChannels,
        country: this.settings.countryCode,
        mobile: this.mobile,
        language: activeWidget.settings.locale,
      },
      this.settings.billingToken
    )
    this.metricsCollector.startCollectingMetrics()
    let metricsCollector = this.metricsCollector

    let whenAiTurnedOn = activeWidget.settings.aiWhen
    let whatAiTurnedOn = activeWidget.settings.aiWhat

    if (whenAiTurnedOn || whatAiTurnedOn) {
      try {
        let { aiInstructions } = await metricsCollector.getInstructions(
          whenAiTurnedOn,
          whatAiTurnedOn,
          activeWidget.settings.locale,
          activeWidget.settings.mlWhen,
          activeWidget.settings.mlWhat
        )

        if (whatAiTurnedOn) {
          let whatGreeting = aiInstructions.what_greeting
          let whatSentence = aiInstructions.what_sentence

          if (whatGreeting && whatSentence) {
            let currentTexts = activeWidget.settings.texts
            let headsupGreeting = currentTexts.find((x) => x.key === 'headsUpTitle' && x.type === 'general')
            let headsupText = currentTexts.find((x) => x.key === 'headsUpText' && x.type === 'general')

            headsupGreeting.value = whatGreeting
            headsupText.value = whatSentence
            activeWidget.settings.texts = currentTexts
          }
        }

        if (whenAiTurnedOn) {
          let whenInstructions = aiInstructions['when_instruction']
          let decisionFunction = atob(whenInstructions['decision_function'])
          this.aiService = new AiService(whenInstructions['X_labels'], whenInstructions['R'], whenInstructions['U'], whenInstructions['K'], decisionFunction)

          this.whenInstructions = whenInstructions
          //turn off headsup triggers
          // probeWhen = false;
          activeWidget.settings.triggers = activeWidget.settings.triggers.filter((x) => x.component !== 'popover')

          setTimeout(() => this.evaluateWhen(this), 2000)
        }

        //get new instructions on each interval
        metricsCollector.addIntervalListener(async () => {
          logger.debug('Getting new instructions')
          let { aiInstructions } = await metricsCollector.getInstructions(
            whenAiTurnedOn,
            whatAiTurnedOn,
            activeWidget.settings.locale,
            activeWidget.settings.mlWhen,
            activeWidget.settings.mlWhat
          )

          if (whenAiTurnedOn) {
            logger.debug('Got new when instructions')
            this.whenInstructions = aiInstructions['when_instruction']

            setTimeout(() => {
              this.evaluateWhen()
            }, 2000)
          }

          if (whatAiTurnedOn) {
            let whatGreeting = aiInstructions.what_greeting
            let whatSentence = aiInstructions.what_sentence

            logger.debug(`Got new what instructions whatGreeting=${whatGreeting} whatSentence=${whatSentence}`)

            if (whatGreeting && whatSentence) {
              let currentTexts = activeWidget.settings.texts
              let headsupGreeting = currentTexts.find((x) => x.key === 'headsUpTitle' && x.type === 'general')
              let headsupText = currentTexts.find((x) => x.key === 'headsUpText' && x.type === 'general')

              headsupGreeting.value = whatGreeting
              headsupText.value = whatSentence
              activeWidget.settings.texts = currentTexts
            }
          }
        })
      } catch (e) {
        logger.error(e)
      }
    }

    try {
      metricsCollector.sendVisitorSessionId()
    } catch (e) {
      logger.error(e)
    }

    this.widgets.forEach((w) => w.initiateActions())
  }

  evaluateWhen() {
    logger.debug('[AI] Evaluating when instructions...')

    const ML_WHEN_HEADSUP_DELAY = 1500

    if (this.isWidgetOpen()) {
      setTimeout(() => {
        this.evaluateWhen()
      }, 2000)
      return
    }

    const MAX_HEADSUP_SHOW_COUNT = 3
    let headsupShowCount = parseInt(this.metricsCollector.readCookie('headsupShowCount') || 0)
    if (headsupShowCount >= MAX_HEADSUP_SHOW_COUNT) {
      logger.debug('[AI] Headsup show count exceeded')
      return
    }

    try {
      let metricsCollector = this.metricsCollector
      let activeWidget = this.widgets[this.widgetIndex]
      let whenInstructions = this.whenInstructions
      let aiService = this.aiService
      try {
        if (!activeWidget.popover.isActive) return
      } catch (e) {
        logger.error(`[AI] Error evaluating when instructions: ${e}`)
      }
      let measures = metricsCollector.getCurrentMetrics()
      let metricObject = {
        account_id: this.accountId,
        widget_id: this.widgetId,
        visitor_id: this.visitorId,
        available_channels: this.availableChannels,
        activity_history: [
          {
            timestamp: new Date().toISOString(),
            url: window.location.origin + window.location.pathname,
            ml_when_model_name: metricsCollector.mlWhenModel,
            ml_what_model_name: metricsCollector.mlWhatModel,
            sentence_hash: metricsCollector.mlSentenceHash,
            measures: measures,
          },
        ],
      }

      logger.debug(`[AI] EvaluateWhen. metricsCollector.widgetMetricsQueue: ${JSON.stringify(metricsCollector.widgetMetricsQueue)}`)

      let queue = new Queue(JSON.stringify(metricsCollector.widgetMetricsQueue))
      queue.enqueue(metricObject.activity_history[0])

      const decisionFunction = atob(whenInstructions['decision_function'])

      logger.debug(`[AI] EvaluateWhen. decisionFunction: ${decisionFunction}`)

      const data = queue.elements
      const measuresVector = aiService.buildMeasuresVector(data)
      const scaledMeasures = aiService.scaleMeasuresVector(measuresVector, whenInstructions['U'], whenInstructions['R'])
      const compressedMeasures = aiService.compressMeasuresVector(scaledMeasures, whenInstructions['K'])

      logger.debug(`[AI] EvaluateWhen. measuresVector: ${JSON.stringify(compressedMeasures)}`)

      let result = aiService.runDecisionTree(compressedMeasures, decisionFunction)

      logger.debug(`[AI] Evaluated when instructions. Result: ${result}`)

      if (result === 1) {
        setTimeout(() => {
          this.triggerPublicEvent('engagement_headsup', {})
          activeWidget.fireTrigger({ component: 'popover', kind: 'timeSpent', value: 0, playsSound: true })
        }, ML_WHEN_HEADSUP_DELAY)
      } else {
        setTimeout(() => {
          this.evaluateWhen()
        }, 2000)
      }
    } catch (e) {
      logger.error(`[AI] Error evaluating when instructions: ${e}`)
      if (e.stack) {
        logger.error(e.stack)
      }

      console.trace()
    }
  }

  async handleSettingsWithPredictiveEngagement(settings) {
    this.debugAccount()

    function acceptOffer(deploymentId, userId, actionId, sessionId, widgetId, widgetAction) {
      const data = {
        actionId: actionId,
        actionState: 'accepted',
        sessionId: sessionId,
        pageUrl: document.location.href,
      }

      const dataS = JSON.stringify(data)
      const dataB = btoa(dataS)

      fetch(`https://api.mypurecloud.de/api/v2/journey/deployments/${deploymentId}/customers/${userId}/beacons?data=${dataB}&type=webactionevent`, {
        method: 'POST',
        mode: 'cors',
      })
      let acceptedOfferInfo = {
        widgetId: widgetId,
        widgetAction: widgetAction,
      }
      localStorage.setItem('trueenegage_accepted_offer_info', JSON.stringify(acceptedOfferInfo))
    }
    let gSessionId = ''
    let genesysUserId = ''
    let wAction = ''
    let widgetId = -1
    let gActionId = -1
    let qualified = false
    let activeWidget = null
    const deploymentId = this.getDeploymentId()

    let acceptedOfferInfoJson = localStorage.getItem('trueenegage_accepted_offer_info')
    let acceptedOfferInfo = JSON.parse(acceptedOfferInfoJson)
    if (acceptedOfferInfo) {
      let widgetData = this.settings.widgets.find((widget) => widget.id === acceptedOfferInfo.widgetId)
      this.widgetIndex = this.settings.widgets.findIndex((widget) => widget.id === acceptedOfferInfo.widgetId)
      const widgetIndex = this.widgetIndex

      const localMlWhen = localStorage.getItem('trueengage-mlwhen')
      const localMlWhat = localStorage.getItem('trueengage-mlwhat')
      if (settings.widgets.length > 0) {
        if (localMlWhen) {
          widgetData.mlWhen = localMlWhen
          widgetData.aiWhen = !!localMlWhen
        }
        if (localMlWhat) {
          widgetData.mlWhat = localMlWhat
          widgetData.aiWhat = !!localMlWhat
        }
      }

      if (!this.isLoaded) {
        this.isLoaded = true
        this.executeAfterLoadingQueue()
      }
      if (!this.settingsLoaded) {
        this.settingsLoaded = true
        this.executeAfterSettingsQueue()
        this.trackPageView()
        this.triggerGoogleTagManagerEvent('visitor_id_set', { visitor_id: this.token })
        this.triggerPublicEvent('widget_loaded')
      }

      this.widgets = []
      const $widgetWindow = templates.widgetWindow(this.getTemplateVariables())
      await this.$element.insertAdjacentHTML('afterbegin', $widgetWindow)

      let decodedToken = JwtParser.parseJwt(widgetData.billingToken)
      const refreshTokenTime = decodedToken.exp * 1000 - Date.now()

      setTimeout(() => {
        this.refreshToken(widgetData.billingToken)
      }, refreshTokenTime)

      const {
        billingService,
        callbackService,
        genesysCallbackService,
        genesysAudioService,
        tokenService,
        whatsappService,
        facebookMessengerService,
        genesysWebMessengerHistoryService,
        genesysVideoService,
        genesysKnowledgeBaseService,
        formSubmissionService,
      } = this.createServices(settings, widgetData.billingToken)

      let widget = new Widget(this, this.$element, widgetData, settings.useGenesysPredictiveEngagement, {
        callbackService,
        genesysWebMessengerHistoryService,
        genesysCallbackService,
        genesysAudioService,
        billingService,
        tokenService,
        whatsappService,
        facebookMessengerService,
        widgetIndex,
        genesysVideoService,
        genesysKnowledgeBaseService,
        formSubmissionService,
      })

      const availableChannels = widget.channels.map((x) => x.channelType)
      this.metricsCollector = new MetricsCollectorService(
        {
          host: config.ai.host,
          statisticsHost: config.statistics.host,
          accountId: this.settings.id,
          widgetId: widget.settings.id,
          visitorId: this.visitor.id,
          availableChannels,
          country: this.settings.countryCode,
          mobile: this.mobile,
          language: widget.settings.locale,
        },
        widgetData.billingToken
      )
      this.metricsCollector.startCollectingMetrics()

      this.widgets.push(widget)
      widget.initiateAction(acceptedOfferInfo.widgetAction)
      activeWidget = widget
    }

    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.classList && node.classList.contains('genesys-app')) {
              console.log('Offer qualified?:' + qualified)
              if (qualified) {
                node.remove()
              }
              if (!qualified) {
                node.style.display = 'none'
                setTimeout(function () {
                  if (!qualified) {
                    node.style.display = 'block'
                  } else {
                    node.remove()
                  }
                }, 2000)
              }
            }
          })
        }
      }
    })
    const obsConfig = {
      childList: true,
      subtree: true,
    }

    observer.observe(document.body, obsConfig)
    Genesys('subscribe', 'Journey.qualifiedContentOffer', async ({ data }) => {
      let title = data.contentOfferProperties.title
      if (title.startsWith('TrueEngage')) {
        gActionId = data.journeyContext.triggeringAction.id

        let genesysVisitorSessionJson = null
        let prefix = null

        for (let i = 0; i < localStorage.length; i++) {
          let key = localStorage.key(i)
          if (key.includes(':actms')) {
            genesysVisitorSessionJson = localStorage.getItem(key)
            prefix = key.split(':actms')[0] // Pobieramy to, co jest przed ":actms"
            break // Przerwij pętlę, gdy znajdziemy pierwszy pasujący klucz
          }
        }
        gSessionId = JSON.parse(genesysVisitorSessionJson).value

        let genesysUserJson = localStorage.getItem(`${prefix}:actmu`)
        genesysUserId = JSON.parse(genesysUserJson).value

        const parts = title.split('_')
        if (parts.length >= 3) {
          qualified = true
          wAction = parts[1]
          widgetId = parts[2]

          if (activeWidget) {
            setTimeout(function () {
              acceptOffer(deploymentId, genesysUserId, gActionId, gSessionId, widgetId, wAction)
            }, 2000)
            if (activeWidget.settings.id === widgetId) {
              return
            }
            activeWidget.destroy()
          } else {
            setTimeout(function () {
              acceptOffer(deploymentId, genesysUserId, gActionId, gSessionId, widgetId, wAction)
            }, 2000)
          }
          let widgetData = this.settings.widgets.find((widget) => widget.id === widgetId)
          this.widgetIndex = this.settings.widgets.findIndex((widget) => widget.id === widgetId)
          const widgetIndex = this.widgetIndex

          if (!this.isLoaded) {
            this.isLoaded = true
            this.executeAfterLoadingQueue()
          }
          if (!this.settingsLoaded) {
            this.settingsLoaded = true
            this.executeAfterSettingsQueue()
            this.trackPageView()
            this.triggerGoogleTagManagerEvent('visitor_id_set', { visitor_id: this.token })
            this.triggerPublicEvent('widget_loaded')
          }

          this.widgets = []
          const $widgetWindow = templates.widgetWindow(this.getTemplateVariables())
          await this.$element.insertAdjacentHTML('afterbegin', $widgetWindow)

          const {
            billingService,
            callbackService,
            genesysCallbackService,
            genesysAudioService,
            tokenService,
            whatsappService,
            facebookMessengerService,
            genesysWebMessengerHistoryService,
            genesysVideoService,
            genesysKnowledgeBaseService,
            formSubmissionService,
          } = this.createServices(settings, widgetData.billingToken, widgetIndex)

          let widget = new Widget(this, this.$element, widgetData, settings.useGenesysPredictiveEngagement, {
            callbackService,
            genesysWebMessengerHistoryService,
            genesysCallbackService,
            genesysAudioService,
            billingService,
            tokenService,
            whatsappService,
            facebookMessengerService,
            widgetIndex,
            genesysVideoService,
            genesysKnowledgeBaseService,
            formSubmissionService,
          })

          const availableChannels = widget.channels.map((x) => x.channelType)
          this.metricsCollector = new MetricsCollectorService(
            {
              host: config.ai.host,
              statisticsHost: config.statistics.host,
              accountId: this.settings.id,
              widgetId: widget.settings.id,
              visitorId: this.visitor.id,
              availableChannels,
              country: this.settings.countryCode,
              mobile: this.mobile,
              language: widget.settings.locale,
            },
            widgetData.billingToken
          )
          this.metricsCollector.startCollectingMetrics()
          let metricsCollector = this.metricsCollector

          let whatAiTurnedOn = widget.settings.aiWhat

          if (whatAiTurnedOn) {
            try {
              let { aiInstructions } = await metricsCollector.getInstructions(
                false,
                whatAiTurnedOn,
                widget.settings.locale,
                widget.settings.mlWhen,
                widget.settings.mlWhat
              )
              if (whatAiTurnedOn) {
                let whatGreeting = aiInstructions.what_greeting
                let whatSentence = aiInstructions.what_sentence

                if (whatGreeting && whatSentence) {
                  let currentTexts = widget.settings.texts
                  let headsupGreeting = currentTexts.find((x) => x.key === 'headsUpTitle' && x.type === 'general')
                  let headsupText = currentTexts.find((x) => x.key === 'headsUpText' && x.type === 'general')

                  headsupGreeting.value = whatGreeting
                  headsupText.value = whatSentence
                  widget.settings.texts = currentTexts
                }
              }
            } catch (e) {
              logger.error(e)
            }
          }

          this.widgets.push(widget)
          widget.initiateAction(wAction)
          activeWidget = widget
        }
      }
    })
  }

  async handleSettings(settings) {
    if (settings.widgets.length === 0) return
    logger.info('[widget] handleSettings ', settings)
    if (!this.geolocated) {
      this.geolocate(settings)
      return
    }

    if (settings.submitsEventsToGoogleAnalytics) {
      this.initiateGoogleAnalytics()
    }

    this.setSettings(settings)

    if (settings.useGenesysPredictiveEngagement) {
      await this.handleSettingsWithPredictiveEngagement(settings)
      return
    }
    await this.handleSettingsWithoutPredictiveEngagement(settings)
  }

  getDeploymentId() {
    // Get all script elements on the page
    const scripts = document.getElementsByTagName('script')

    // Loop through all script elements
    for (let script of scripts) {
      // Check if the script contains the specific pattern
      if (script.textContent.includes("g['_genesysJs']") && script.textContent.includes('deploymentId')) {
        // Extract the deploymentId using a regular expression
        const regex = /deploymentId:\s*'([^']+)'/
        const match = script.textContent.match(regex)

        if (match && match[1]) {
          return match[1]
        }
      }
    }

    // Return null if no matching script or deploymentId is found
    return null
  }

  getTemplateVariables() {
    const isAgentsOnline = this.settings.widgets[this.widgetIndex].channels.some(
      (channel) => channel.type === 'genesysWebMessenger' || channel.type === 'genesysAudio'
    )
    let logoStatus = 'off'
    let logotype = 'background'
    let logoUrl = ''
    let avatarsStatus = 'on'

    if (this.settings.widgets[this.widgetIndex].logo) {
      if (this.settings.widgets[this.widgetIndex].logo.status) {
        logoStatus = this.settings.widgets[this.widgetIndex].logo.status
      }
      if (this.settings.widgets[this.widgetIndex].logo.url) {
        logoUrl = this.settings.widgets[this.widgetIndex].logo.url
      }
      if (this.settings.widgets[this.widgetIndex].logo.type) {
        logotype = this.settings.widgets[this.widgetIndex].logo.type
      }
    }

    if (this.settings.widgets[this.widgetIndex].avatarsStatus) {
      avatarsStatus = this.settings.widgets[this.widgetIndex].avatarsStatus
    }

    return {
      texts: this.settings.widgets[this.widgetIndex].texts.filter((x) => x.type === 'general' || x.type === 'chat'),
      channels: this.settings.widgets[this.widgetIndex].channels,
      agentImages: this.settings.widgets[this.widgetIndex].agentGraphics,
      botImage: this.settings.widgets[this.widgetIndex].botGraphic,
      agentStatus: isAgentsOnline,
      avatarsStatus: avatarsStatus,
      logoStatus: logoStatus,
      logoUrl: logoUrl,
      logoType: logotype,
    }
  }

  trackPageView() {
    try {
      let country = this.settings.countryCode
      this.statisticsService.trackPageVisit(this.settings.widgets[this.widgetIndex].id, this.settings.id, this.token, country)
    } catch (e) {
      logger.warn(e)
    }
  }

  geolocate(settings) {
    try {
      logger.info('[container] geolocate')
      const controller = new AbortController()
      const timeoutId = setTimeout(() => controller.abort(), 1500)

      fetch(config.geoip.host, { signal: controller.signal })
        .then((response) => {
          clearTimeout(timeoutId)
          return response.json()
        })
        .then((data) => {
          logger.info('[container] geolocate data ', data)
          settings.countryCode = data.country_code.toLowerCase()
          this.geolocated = true
          this.handleSettings(settings)
        })
        .catch((err) => {
          logger.info('[container] geolocate error ', err)
          clearTimeout(timeoutId)
          this.geolocated = true
          this.handleSettings(settings)
        })
    } catch (e) {}
  }

  getIsInDebugMode() {
    return localStorage.cceDebugMode === 'true'
  }

  debugInstallation() {
    this.printDebugInformation('Installation', {
      'Signalling Host': config.signalling.host,
      'Visitor ID': this.token,
      'Account ID': this.settings.id.toString(),
    })
  }

  debugAccount() {
    this.printDebugInformation('Account', {
      ID: this.settings.id.toString(),
      State: this.settings.state,
      'Call execution method': this.settings.callKind,
      'Chat enabled': this.settings.chatName || 'no',
    })
  }

  printDebugInformation(header, props) {
    if (!this.getIsInDebugMode()) {
      return
    }
    const prefix = '%cCCE DEBUG:%c'
    const keyLength = Math.max(..._.map(_.keys(props), (k) => k.length))
    const valueLength = Math.max(..._.map(_.keys(props), (k) => props[k].length))

    let lines = _.map(_.keys(props), (k) => `${k}:${Array(keyLength - k.length + 2).join(' ')}%c${props[k]}`)
    header = `* ${header} ` + Array(keyLength + valueLength - header.length + 3).join('*')
    lines = _.map(lines, (l) => `${prefix}   ${l}`)
    lines.unshift(`${prefix} ${header}`)
    lines.push(prefix + ' ' + Array(header.length + 1).join('*'))

    let colors = ['color: #ccc', 'color: #1f85ff;']

    for (let i = 0; i < lines.length - 2; i++) {
      colors.push('color: #ccc')
      colors.push('color: #666;')
      colors.push('color: black;')
    }

    colors.push('color: #ccc')
    colors.push('color: #1f85ff;')

    logger.log(lines.join('\n'), ...colors)
  }

  setActiveWidget(triggerKind, widget) {
    if (this.activeWidgets[triggerKind] && this.activeWidgets[triggerKind] !== widget) {
      return false
    } else {
      this.activeWidgets[triggerKind] = widget
      return true
    }
  }

  getFiredTriggerComponents(options) {
    return _.reduce(
      _.filter(this.firedTriggerComponentsByFilterId, function (triggers) {
        return triggers.filterId !== options.excludeFilterId
      }),
      function (memo, triggers) {
        return memo.concat(triggers.components)
      },
      []
    )
  }

  canFireTriggerForFilter(trigger, filterId) {
    return (
      this.settings.triggerFireingMode === 'fire_triggers_independently' ||
      this.getFiredTriggerComponents({ excludeFilterId: filterId }).indexOf(trigger.component) < 0
    )
  }

  handleTriggerFired(trigger, filterId) {
    var triggers = _.find(this.firedTriggerComponentsByFilterId, function (triggers) {
      return triggers.filterId === filterId
    })
    if (!triggers) {
      triggers = {
        filterId,
        components: [],
      }
      this.firedTriggerComponentsByFilterId.push(triggers)
    }

    triggers.components.push(trigger.component)

    var cookieName = this.cookieName + '-firedTriggerComponentsByFilterId'
    localStorage[cookieName] = JSON.stringify(this.firedTriggerComponentsByFilterId)
  }

  setSettings(settings) {
    this.settings = Object.assign({}, this.settings, this.defaultSettings, settings)
    this.settings.mode = this.settings.callKind === 'callback' ? 'callback' : 'passive'
    return this.settings
  }

  executeAfterLoadingQueue() {
    this.afterLoadingQueue.forEach(
      (function (_this) {
        return function (callback) {
          return callback()
        }
      })(this)
    )
    return (this.afterLoadingQueue = [])
  }

  executeAfterSettingsQueue() {
    this.afterSettingsQueue.forEach(
      (function (_this) {
        return function (callback) {
          return callback()
        }
      })(this)
    )
    return (this.afterSettingsQueue = [])
  }

  postLocation() {
    this.refreshTrackingParams()
    fetch(`${config.signalling.host}/accounts/${this.settings.id}/locations`, {
      method: 'POST',
      body: JSON.stringify(this.getLocationData()),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((s) => this.handleSettings(s))
      .catch((error) => {
        logger.error('Failed to load CCE settings', error)
      })
  }

  getResolution() {
    const realWidth = window.screen.width * window.devicePixelRatio
    const realHeight = window.screen.height * window.devicePixelRatio
    return { w: realWidth, h: realHeight }
  }

  getLocationData() {
    let activeChannels = []
    try {
      const activeChannelKeys = Object.keys(localStorage).filter((k) => k.startsWith('trueengage-activeChannel'))
      if (activeChannelKeys && activeChannelKeys.length > 0) {
        activeChannels = activeChannelKeys.map((k) => Object.assign(JSON.parse(localStorage.getItem(k)), { widgetId: parseInt(k.split('-')[2]) }))
      }
    } catch (e) {
      logger.warn('Failed to get active channels', e)
    }

    return {
      visitorId: this.token,
      currentCallId: this.visitor.currentCallId,
      targetGroupId: this.settings.targetGroupId,
      targetedUserId: this.settings.targetedUserId,
      targetedDepartmentId: this.settings.targetedDepartmentId,
      url: window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search,
      title: document.title,
      visitorReference: this.settings.visitorReference,
      deviceKind: this.getDeviceKind(),
      referrer: this.visitor.referrer,
      trackingParams: this.trackingParams,
      googleAnalyticsClientId: this.googleAnalyticsClientId,
      googleAnalyticsTrackingId: this.googleAnalyticsTrackingId,
      screen: this.getResolution(),
      activeChannels: activeChannels,
    }
  }

  getReferrer() {
    if (document.referrer.indexOf(location.protocol + '//' + location.host) !== 0) {
      return document.referrer
    }
  }

  refreshTrackingParams() {
    let cookieName = this.cookieName + '-utm'
    if (!this.trackingParams) {
      let storedTrackingParams = localStorage[cookieName]

      try {
        this.trackingParams = JSON.parse(storedTrackingParams)
      } catch (SyntaxError) {
        this.trackingParams = {}
      }
    }

    let newTrackingParams = {}
    let url

    try {
      url = new URL(document.location)
    } catch (e) {
      logger.warn('URL unsupported. Tracking params will not be recorded')
      return
    }

    if (url.searchParams) {
      _.forEach(['source', 'medium', 'campaign', 'term', 'content'], (param) => {
        let value = url.searchParams.get(`utm_${param}`)
        if (value) {
          newTrackingParams[`utm_${param}`] = value
        }
      })

      _.forEach(this.settings.trackingParams, (param) => {
        let value = url.searchParams.get(param.name)
        if (value) {
          newTrackingParams[param.name] = value
        }
      })
    }

    _.extend(this.trackingParams, newTrackingParams)

    cookieConsentManager.setLocalStorageItem(cookieName, JSON.stringify(this.trackingParams), 'necessary')
  }

  getDeviceKind() {
    return 'desktop'
    // TODO fix getDeviceKind function
    let md
    md = new MobileDetect(window.navigator.userAgent)
    if (md.phone() != null || md.tablet() != null) {
      return 'mobile'
    } else {
      return 'desktop'
    }
  }

  readCookie(name) {
    var c, ca, i, nameEQ, ref, x
    nameEQ = name + '='
    ca = document.cookie.split(';')
    for (x = i = 0, ref = ca.length - 1; 0 <= ref ? i <= ref : i >= ref; x = 0 <= ref ? ++i : --i) {
      c = ca[x]
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
    }
    return null
  }

  createCookie(name, value, category = 'necessary') {
    if (!cookieConsentManager.hasConsent(category)) return

    var expiration
    expiration = new Date()
    expiration.setTime(expiration.getTime() + 3600 * 1000 * 24 * 365)
    return (document.cookie = name + '=' + escape(value) + ';expires=' + expiration.toGMTString() + ';path=/')
  }

  triggerPublicEvent(eventName, data) {
    let event, fullEventName
    fullEventName = 'trueengage:' + eventName
    event = new CustomEvent(fullEventName, { detail: data })
    document.dispatchEvent(event)

    data = data || {}
    try {
      let country = this.settings.countryCode
      this.statisticsService.trackWidgetEvent(
        this.settings.widgets[this.widgetIndex].id,
        this.settings.id,
        this.token,
        country,
        data.communication_channel,
        eventName
      )
    } catch (e) {
      logger.warn(e)
    }

    this.triggerGoogleTagManagerEvent(eventName, data)
    this.triggerFacebookPixelEvent(eventName, data)
  }

  triggerGoogleAnalyticsEvent(eventName, data) {
    let category = this.settings.whitelabelName || 'LiveEngage'
    let interactionEvents = ['callInitiation']
    let nonInteraction = interactionEvents.indexOf(eventName) < 0
    let isExcluded =
      (this.settings.eventsExcludedFromGoogleAnalytics && this.settings.eventsExcludedFromGoogleAnalytics.split(/[,\s]+/).indexOf(eventName) > -1) ||
      EVENTS_EXLUDED_FROM_GOOGLE_ANALYTICS.indexOf(eventName) > -1
    let label = data ? data.label : null
    if (this.settings.submitsEventsToGoogleAnalytics && !isExcluded) {
      if (typeof ga !== 'undefined' && ga !== null) {
        ga('send', {
          hitType: 'event',
          eventCategory: category,
          eventAction: eventName,
          eventLabel: label,
          nonInteraction: nonInteraction,
        })
      }
      if (typeof gtag !== 'undefined' && gtag !== null) {
        gtag('event', eventName, {
          event_category: category,
          event_label: label,
          non_interaction: nonInteraction,
        })
      }
    }

    if (this.settings.submitsEvents) {
      fetch(`${config.signalling.host}/accounts/${this.settings.id}/events`, {
        method: 'POST',
        body: JSON.stringify({
          clientId: this.token,
          accountId: this.settings.id,
          eventCategory: category,
          eventAction: eventName,
          eventLabel: label,
          nonInteraction: nonInteraction ? 1 : 0,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
    }
  }

  triggerGoogleTagManagerEvent(eventName, data) {
    if (this.settings.submitsEventsToGoogleAnalytics) {
      if (typeof dataLayer === 'undefined' || dataLayer === null) {
        window.dataLayer = []
      }
      let eventData = data || {}
      eventData['event'] = `te_${eventName}`
      eventData['visitor_id'] = this.token
      try {
        eventData['widget_id'] = this.settings.widgets[this.widgetIndex].id
        eventData['widget_name'] = this.settings.widgets[this.widgetIndex].name
      } catch (e) {
        logger.warn(e)
      }
      dataLayer.push(eventData)
    }
  }

  triggerFacebookPixelEvent(eventName) {
    let category = this.settings.whitelabelName || 'LiveEngage'
    if (this.settings.submitsEventsToFacebookPixel) {
      if (typeof fbq !== 'undefined' && fbq !== null) {
        fbq('trackCustom', `${category}_${eventName}`)
      }
    }
  }
}
